import { cx } from "@emotion/css";
import MuiTooltip from "@mui/material/Tooltip";
import type { ReactNode } from "react";

interface TooltipProps {
	title: ReactNode;
	children: ReactNode;
	className?: string;
	wrapperClassName?: string;
	open?: boolean;
	enterDelay?: number;
	enterNextDelay?: number;
	enterTouchDelay?: number;
	leaveTouchDelay?: number;
	disabled?: boolean;
}

export const Tooltip = ({
	title,
	children,
	className,
	wrapperClassName,
	open,
	enterDelay = 500,
	enterNextDelay = 500,
	enterTouchDelay = 250,
	leaveTouchDelay = 1500,
	disabled = false,
}: TooltipProps) => {
	return (
		<MuiTooltip
			className={className}
			title={title}
			enterDelay={enterDelay}
			enterNextDelay={enterNextDelay}
			enterTouchDelay={enterTouchDelay}
			leaveTouchDelay={leaveTouchDelay}
			open={open}
			disableFocusListener={disabled}
			disableHoverListener={disabled}
			disableInteractive={disabled}
			disableTouchListener={disabled}
		>
			<div className={cx(wrapperClassName)}>{children}</div>
		</MuiTooltip>
	);
};
